// @flow
export type ActionType =
  | {|
      type: 'STORE_PHONE_NUMBERS',
      phoneNumbers: string[],
    |}
  | {|
      type: 'FETCH_AVAILABLE_PHONE_NUMBERS',
      payload: {
        preferredPhoneNumbers: ?string,
      },
    |}
  | {|
      type: 'SET_CURRENT_PHONE_NUMBER',
      currentPhoneNumber: string,
    |}
  | {|
      type: 'DELETE_CURRENT_SHOWN_PHONE_NUMBERS',
    |}
  | {|
      type: 'SHOW_NEW_PHONE_NUMBERS',
    |};

export function storePhoneNumbers(phoneNumbers: string[]): ActionType {
  return {
    type: 'STORE_PHONE_NUMBERS',
    phoneNumbers,
  };
}
export function fetchAvailablePhoneNumbers(preferredPhoneNumbers: ?string): ActionType {
  return {
    type: 'FETCH_AVAILABLE_PHONE_NUMBERS',
    payload: { preferredPhoneNumbers },
  };
}

export const setCurrentPhoneNumber = (currentPhoneNumber: string): ActionType => ({
  type: 'SET_CURRENT_PHONE_NUMBER',
  currentPhoneNumber,
});

export const deleteCurrentShownPhoneNumbers = (): ActionType => ({
  type: 'DELETE_CURRENT_SHOWN_PHONE_NUMBERS',
});

export const showNewPhoneNumbers = (): ActionType => ({
  type: 'SHOW_NEW_PHONE_NUMBERS',
});
